/**
 * Extract ids (format: ${sublistId}-${itemId}) of all checked items from JSON string.
 * String accessed either from local storage or our API.
 * @param {String} str a JSON-stringified array of ids of checked items 
 * @returns {Set} to be stored in state
 */
export const parseCheckedItems = (str) => new Set(JSON.parse(str));

/**
 * Create a JSON string from a set of ids (format: ${sublistId}-${itemId}) of all checked items. 
 * String stored either in local storage, or sent to our database
 * @param {Set} state - the set 'userCheckedItems' from state
 * @param {String} key - the ${sublistId}-{itemId} for the just-checked/unchecked item
 * @returns {undefined} 
 */
export const createCheckedItemsKey = (state, key) => {
    const clone = new Set(state);
    if (clone.has(key)) clone.delete(key);
    else clone.add(key);
    return JSON.stringify([...clone]);
};
